import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class PrintNodeService {
  private readonly httpService = inject(HttpService);

  private readonly apiUrl = 'TmsWeb/PrintNode';

  // The document size is the printer's label setup. Browser-built label templates carry no
  // @page rule, so without it the API renders a Letter page and the label printer shrinks it
  // and turns it sideways. Zero leaves the page size to the HTML.
  printHtml(
    printerId: number,
    content: string,
    title: string,
    copies = 1,
    documentWidth = 0,
    documentHeight = 0,
    documentUnits = 'IN',
  ): Observable<number> {
    return this.httpService.post<number>(`${this.apiUrl}/PrintHtml`, {
      printerId,
      content,
      title,
      copies,
      documentWidth,
      documentHeight,
      documentUnits,
    });
  }

  printPdf(
    printerId: number,
    content: string,
    title: string,
    copies = 1,
    contentType = 'pdf_base64',
  ): Observable<number> {
    return this.httpService.post<number>(`${this.apiUrl}/PrintPdf`, {
      printerId,
      content,
      title,
      copies,
      contentType,
    });
  }

  printStockLabel(
    printerId: number,
    stockItemId: string,
    title: string,
    copies = 1,
    printBarcode = false,
    printQRCode = false,
    documentSize = 'SMALL',
    documentWidth = 0,
    documentHeight = 0,
    documentUnits = 'IN',
  ): Observable<number> {
    return this.httpService.post<number>(`${this.apiUrl}/PrintStockLabel`, {
      printerId,
      reportId: stockItemId,
      title,
      copies,
      printBarcode,
      printQRCode,
      documentSize,
      documentWidth,
      documentHeight,
      documentUnits,
    });
  }

  getPrinters(): Observable<any[]> {
    return this.httpService.get<any[]>(`${this.apiUrl}/Printers`);
  }

  getComputers(): Observable<any[]> {
    return this.httpService.get<any[]>(`${this.apiUrl}/Computers`);
  }

  getPrintersForComputer(computerId: number): Observable<any[]> {
    return this.httpService.get<any[]>(`${this.apiUrl}/PrintersForComputer/${computerId}`);
  }

  getPrintJob(printJobId: number): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/PrintJob/${printJobId}`);
  }

  getPrintJobs(limit = 25): Observable<any[]> {
    return this.httpService.get<any[]>(`${this.apiUrl}/PrintJobs?limit=${limit}`);
  }

  whoAmI(): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/WhoAmI`);
  }
}
